"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _styledComponents.default.div.withConfig({
  displayName: "WhiteCurtain",
  componentId: "design-system__zqx6ip-0"
})(["position:fixed;z-index:20000;left:0px;top:0px;width:100%;height:100%;background-color:rgba(255,255,255,0.8);overflow:auto;display:flex;align-items:center;justify-content:center;"]);

exports.default = _default;